"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonActions_en_us = void 0;
function commonActions_en_us() {
    return {
        "actions.close": "close",
        "actions.save": "save",
        "actions.cancel": "cancel",
        "actions.create": "create",
        "actions.yes": "yes",
        "actions.no": "no",
        "actions.dialogdismiss": "close",
        "actions.add": "add",
        "actions.edit": "edit",
        "actions.delete": "delete",
        "actions.ok": "ok",
        "actions.search": "search",
        "actions.reset": "reset",
        "actions.skip": "skip",
        "actions.print": "print",
        "actions.refresh": "refresh",
        "actions.select": "select",
        "actions.done": "done",
        "actions.more": "more",
        "actions.enable": "enable",
        "actions.disable": "disable",
        "actions.accept": "accept",
        "actions.download": "download",
        "actions.upload": "upload",
        "actions.showall": "show all",
        "actions.submit": "submit",
        "actions.addnote": "add note",
        "actions.learn": "Learn more!",
        "actions.continue": "continue",
        "actions.disconnect": "disconnect",
        "actions.open": "open",
        "actions.donotshowagain": "Do not show again!",
        "actions.import": "import",
        "actions.check": "check",
        "actions.openinnewwindow": "open in new window",
        "actions.restore": "Restore"
    };
}
exports.commonActions_en_us = commonActions_en_us;
